'use client'

import { useEffect, useLayoutEffect, useState } from "react";

/**
 * Modified from link below
 * @see https://observablehq.com/@werehamster/avoiding-hydration-mismatch-when-using-react-hooks
 * @param mediaQueryString
 * @returns {unknown}
 */

const useIsoMorphicLayoutEffect =
	typeof window !== "undefined" ? useLayoutEffect : useEffect;

export function useMediaQuery(mediaQueryString: string) {
	const [matches, setMatches] = useState<boolean>();

	useIsoMorphicLayoutEffect(() => {
		if (typeof window === "undefined") return;
		const mediaQueryList = window.matchMedia(mediaQueryString);
		const listener = () => setMatches(!!mediaQueryList.matches);
		listener();
		mediaQueryList.addEventListener("change", listener); // updated from .addListener
		return () => mediaQueryList.removeEventListener("change", listener); // updated from .removeListener
	}, [mediaQueryString]);

	return matches;
}
